export default {
      id: "color_man-usage",
      viewBox: "0 0 86 94",
      url: __webpack_public_path__ + "sprite.svg#color_man",
      toString: function () {
        return this.url;
      }
    }